import React from 'react';
import Helmet from 'react-helmet';

import Layout from '../components/Layout';
import IntroSubPages from '../components/Intro/IntroSubPages';
import GridGroup from '../components/Common/GridGroup';
import Container from '../components/Container';
import HeadingComponent from '../components/Common/HeadingComponent/HeadingComponent';
import ExpandableComponent from '../components/Common/Components/ExpandableComponent';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
} from 'reactstrap';
import Chip from '@material-ui/core/Chip';
import FaceIcon from '@material-ui/icons/Face';

import Seo from '../components/SEO';
import header_image from '../assets/images/sub-pages/pricing/intro.png';
import { Grid } from '@material-ui/core';
import CardTypeThree from '../components/Common/CardTypeThree';

import CustomSoftware from '../assets/images/sub-pages/pricing/expandable/Custom-software.svg';
import TerraformKubernetes from '../assets/images/sub-pages/pricing/expandable/Terraform-Kubernetes.svg';
import AWSJitsi from '../assets/images/sub-pages/pricing/expandable/AWS-Jitsi.svg';
import LoadTesting from '../assets/images/sub-pages/pricing/expandable/Load-testing.svg';
import AuditingJitsi from '../assets/images/sub-pages/pricing/expandable/Auditing-Jitsi.svg';
import MeetrixMeet from '../assets/images/sub-pages/pricing/expandable/Meetrix-Meet-MM.svg';

import MMS from '../assets/images/sub-pages/pricing/mm-feature/MMS.svg';
import MMH from '../assets/images/sub-pages/pricing/mm-feature/MMH.svg';
import MME from '../assets/images/sub-pages/pricing/mm-feature/MME.svg';
import MMEE from '../assets/images/sub-pages/pricing/mm-feature/MMEE.svg';

import Breakoutrooms from '../assets/images/sub-pages/pricing/tags/Breakout-rooms.svg';
import Chat from '../assets/images/sub-pages/pricing/tags/Chat.svg';
import Endtoend from '../assets/images/sub-pages/pricing/tags/End-to-end.svg';
import FileSharing from '../assets/images/sub-pages/pricing/tags/File-sharing.svg';
import Lobby from '../assets/images/sub-pages/pricing/tags/lobby.svg';
import MeetingScheduler from '../assets/images/sub-pages/pricing/tags/Meeting-scheduler.svg';
import Moderator from '../assets/images/sub-pages/pricing/tags/Moderator.svg';
import PeertoPeer from '../assets/images/sub-pages/pricing/tags/Peer-to-peer.svg';
import ScreenShare from '../assets/images/sub-pages/pricing/tags/Screen-Share.svg';
import TileView from '../assets/images/sub-pages/pricing/tags/Tile-view.svg';
import VideoandAudio from '../assets/images/sub-pages/pricing/tags/Video-and-audio.svg';
import Virtual from '../assets/images/sub-pages/pricing/tags/Virtual.svg';

import DashboardSS from '../assets/images/sub-pages/pricing/slider/Dashboard-ss.png';
import DashboardOverviewSS from '../assets/images/sub-pages/pricing/slider/Dashboard-Overview-ss.png';
import DashboardUsersSS from '../assets/images/sub-pages/pricing/slider/Dashboard-Users-ss.png';

// import BlackFridayBanner from '../components/Banners/BlackFridayBanner';

const MeetrixMeetingCarousel = [
  {
    key: 1,
    image: DashboardOverviewSS,
  },
  {
    key: 2,
    image: DashboardSS,
  },
  {
    key: 3,
    image: DashboardUsersSS,
  },
]

const tagList = [
  {
    icon: Breakoutrooms,
    label: 'Breakout rooms'
  },
  {
    icon: TileView,
    label: 'Tile view and presenter view'
  },
  {
    icon: FileSharing,
    label: 'File and attachment sharing'
  },
  {
    icon: Virtual,
    label: 'Virtual background and blurred mode'
  },
  {
    icon: Moderator,
    label: 'Moderator and participant roles'
  },
  {
    icon: VideoandAudio,
    label: 'Video and audio conferencing'
  },
  {
    icon: Endtoend,
    label: 'End-to-end encryption'
  },
  {
    icon: ScreenShare,
    label: 'Screen Share'
  },
  {
    icon: Chat,
    label: 'Chat and white board'
  },
  {
    icon: MeetingScheduler,
    label: 'Meeting scheduler and usage reports'
  },
  {
    icon: PeertoPeer,
    label: 'Peer to peer mode'
  },
  {
    icon: Lobby,
    label: 'Lobby and waiting area with a custom message'
  }
]


const FeatureList = [
  {
    icon: MMS,
    heading: 'Meetrix Meet For Sales - MMS (GDPR Compliant)',
    // subHeading: 'Starting from',
    description: 'Have you ever wanted to sell your products through live discussions and demos to your clients? Individual or group sales are now just a few hours away! We have a pre-built, highly interoperable web version on offer that works just as well on all major Android and Apple mobile devices.'
  },
  {
    icon: MMH,
    heading: 'Meetrix Meet For Healthcare - MMH (GDPR Compliant)',
    // subHeading: 'Starting from',
    description: 'Doctor-Patient one-to-one discussions made easy and private with MMH - a GDPR compliant telehealth software with end-to-end encryption. Contact us for corporate or individual setup needs today.'
  },
  {
    icon: MME,
    heading: 'Meetrix Meet For Education - MME (GDPR Compliant)',
    // subHeading: 'Starting from',
    description: 'If you are a school, university, or tuition provider with needs to support one-to-one or classes with up to 50 students, MME is the perfect solution for your needs.'
  },
  {
    icon: MMEE,
    heading: 'Meetrix Meet For Entertainment - MMEE',
    // subHeading: 'Starting from',
    description: 'Host up to 500 participants and live stream to thousands more. The interactive live chat and moderator-enabled audio/ video for any participant is just the tip of the iceberg of MMEE.'
  },
]

const PricingPage = () => {

  const [activeIndex, setActiveIndex] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === MeetrixMeetingCarousel.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? MeetrixMeetingCarousel.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const Description =
    'Meetrix provides multi-platform, open-source video conferencing solutions based on Jitsi, Janus, Big Blue Button, Kurento, Freeswitch, Twilio, and many others. Our focus on Jitsi has been recognized by hundreds of global sector leaders from a multitude of segments, such as military, government, NGO, telecom, software, and healthcare. They seek our professional services in upgrading, load testing, customization, infrastructure setup and automation, modifications, and integrations of Jitsi.';
  return (
    <Layout pageName="Pricing">
      <Seo title="Meetrix.IO | Pricing" description={Description} />
      <Helmet>
      {/* Global site tag (gtag.js) - Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=UA-118777783-1"></script>
      <script type="text/javascript">
        {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'UA-118777783-1');`}
      </script>
      {/* <!-- Google Tag Manager --> */}
      <script type="text/javascript">{`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-N8NWRND');
      `}</script>
      {/* <!-- End Google Tag Manager --> */}

      {/* <!-- Google tag (gtag.js) --> */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-20D2B15V4Y"></script>
      <script>
        {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-20D2B15V4Y');`}
      </script>
      </Helmet>
      {/* <!-- Google Tag Manager (noscript) --> */}
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N8NWRND"
      height="0" width="0" style={{display:'none', visibility:'hidden' }}></iframe></noscript>
      {/* <!-- End Google Tag Manager (noscript) --> */}
      <IntroSubPages
        heading="Pricing Plans"
        description={<>Meetrix provides multi-platform, open-source video conferencing solutions based on Jitsi, Janus, Big Blue Button, Kurento, Freeswitch, Twilio, and many others.
        <br/><br/>
        Our focus on Jitsi has been recognized by hundreds of global sector leaders from a multitude of segments, such as military, government, NGO, telecom, software, and healthcare. They seek our professional services in upgrading, load testing, customization, infrastructure setup and automation, modifications, and integrations of Jitsi.
        </>}
        buttonOneText="View Plans"
        buttonOneUrl="#pricing-plan"
        image={header_image}
      />
      {/* <BlackFridayBanner /> */}
      <div className="pricing-plan-wrapper" id="pricing-plan">
        <Container>
          <HeadingComponent strongText="Select a service based pricing plan" />
          <ExpandableComponent
            icon={CustomSoftware}
            mainHeading="Custom Software Development Plans"
            blueHeading="Starting from 50/hourly-priced"
          >
            <p>
              We provide hourly-charged, custom development services for a diverse segment of use cases. Our core stack is JS-based over NodeJS/ React and extends to C++, Java, Lua, and Erlang for back-end customizations.
              <br /><br />
              Our rates start from <b>USD 50/ hour</b> for software engineers and extend up to <b>USD 150/ hour</b> for system architects. Get in touch with us to discuss your bespoke requirements for real-time audio and video conferencing systems and receive a quick or detailed quote.
            </p>
          </ExpandableComponent>

          <ExpandableComponent
            icon={TerraformKubernetes}
            mainHeading="Terraform/ Kubernetes Script Customisations For Automatic Infrastructure Deployment"
            blueHeading="Starting from USD 2500"
          >
            <p>
              We provide multi-platform infrastructure automation services for a wide range of open-source software. Rates start at USD 2500.
            </p>
          </ExpandableComponent>

          <ExpandableComponent
            icon={AWSJitsi}
            mainHeading="Best Seller Alert - Aws Jitsi Automated Infrastructure Deployment With Auto-Scaling"
            blueHeading="Starting from USD 1500 /- annum"
          >
            <p>
              Head over to Amazon Marketplace and deploy your own Jitsi infrastructure for your corporate right now. The power of self-service automation means you control your video conferencing destiny on your own infrastructure. And the best part is you are assured of a high-quality setup minus the bother of talking to developers or managing the headaches of security. Head over to AWS Market place.
            </p>
          </ExpandableComponent>

          <ExpandableComponent
            icon={LoadTesting}
            mainHeading="Load Testing (Jitsi Or Any Other Platform) And Certification Of Video Conferencing Platforms"
            blueHeading="Starting from USD 0.99"
          >
            <p>
              Your developer said it can handle 1000 concurrent users, but how can you be sure? Here’s where we can help you be sure about their claims and have peace of mind by knowing your customers will enjoy a seamless experience.
              <br /><br />
              Our load testing rates range from USD 2/- to USD 0.99 per bot depending on load scales. Test reports are delivered within 36hours from payment.
            </p>
          </ExpandableComponent>

          <ExpandableComponent
            icon={AuditingJitsi}
            mainHeading="Auditing Jitsi Or Any Other Video Conferencing Platform"
            blueHeading="Starting from USD 500"
          >
            <p>
              Do poor video quality or disconnections keep your video conferencing platform from performing as it should? We have the answer for why your platform is performing the way it is as well as the solution to your problem. Our seasoned WebRTC experts and DevOps engineers are here to provide you with the peace of mind and professional services you are looking for.
              <br /><br />
              The basic audits start from USD 500 and upwards for large-scale deployments.
            </p>
          </ExpandableComponent>
        </Container>
      </div>
      <div className="meetrix-meet-wrapper">
        <Container>
          <ExpandableComponent
            expanded={true}
            icon={MeetrixMeet}
            mainHeading="Meetrix Meet - MM"
            // blueHeading="Starting from"
          >
            <p>
              We provide a highly scalable and customized version of Jitsi minus all the luggage which makes it bulky. Try before you buy here…
              <br /><br />
              You can deploy your own branded meeting solution within minutes, and embed it conveniently into your WordPress or Wix website, a CRM of your choices such as Hubspot, or an ERP such as Sage or SAP. The clean UIs and file sharing features with end-to-end encrypted video and audio conferencing are all you need to step into the new age of selling and connecting with video.
            </p>

            <div className="carousel-wrapper">
              {/* <Container> */}
              <Carousel
                activeIndex={activeIndex}
                next={next}
                previous={previous}
                interval={false}
              >
                <CarouselIndicators
                  items={MeetrixMeetingCarousel}
                  activeIndex={activeIndex}
                  onClickHandler={goToIndex}
                />
                {MeetrixMeetingCarousel.map((item) => {
                  return (
                    <CarouselItem
                      onExiting={() => setAnimating(true)}
                      onExited={() => setAnimating(false)}
                      key={item.key}
                    >
                      <img src={item.image} className="carousel-image" />
                    </CarouselItem>
                  )
                })}
              </Carousel>
              {/* </Container> */}
            </div>
            <div className="tags-wrapper">
              {tagList.map((item) => {
                return (
                  <Chip
                    icon={<img src={item.icon} />}
                    label={item.label}
                    className="small-font"
                  />
                )
              })}
            </div>
          </ExpandableComponent>

          <div className="feature-cards-wrapper">
            <Grid container>
              {FeatureList.map((feature) => {
                return (
                  <Grid className="card-wrapper" sm={6} >
                      <CardTypeThree
                        icon={feature.icon}
                        heading={feature.heading}
                        subHeading={feature.subHeading}
                        description={feature.description}
                      />
                  </Grid>
                )
              })}
            </Grid>
          </div>
        </Container>
      </div>
    </Layout>
  );
};

export default PricingPage;
